import { render, staticRenderFns } from "./DemandExtractionDialog.vue?vue&type=template&id=b9613cfa&"
import script from "./DemandExtractionDialog.vue?vue&type=script&lang=js&"
export * from "./DemandExtractionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports